import React from 'react';
import { RadioGroup } from '../../components/shared';
import featureFlags from '../../utils/featureFlags'

const OPTIONS = [
    {
        value: 'systemGenerated',
        name: 'systemGenerated',
        label: 'System Generated'
    },
    {
        value: 'manuallySetPricing',
        name: 'manuallySetPricing',
        label: 'Manually Set'
    },
]

export default function PriceInputSelector({
    onChange,
    defaultValue
}) {
    let value = 'systemGenerated'
    if (defaultValue) value = 'manuallySetPricing'
    return (
        <div className='priceInputSelectorContainer'>
            <h4 className='quoteTitle'>Rates and GC Limits</h4>
            <RadioGroup
                options={OPTIONS}
                onChange={onChange}
                name='price-input-selector'
                value={value}
            />
        </div>
    )
}
